import { request } from '@/utils/request'

const prefix = '/user-api'

export function userInfo() {
  return request.get(`${prefix}/user`)
}